import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Element } from 'react-scroll';
import { path } from 'ramda';

import { GiftCertificateBalance } from '@components/PDP/giftCertificateBalance';
import { GiftCertificateTerms } from '@components/PDP/giftCertificateTerms';
import { GiftCertificateSidebar } from '@components/PDP/giftCertificateSidebar';
import { GIFT_BALANCE_LINK, GIFT_TERMS_LINK } from '@components/PDP/pdp.constants';
import { GiftCertificateActions } from '@components/PDP/giftCertificateActions';
import { Variant } from '@definitions/giftCertificate.types';

import {
  Container,
  Content,
  CardContainer,
  Card,
  CardCopy,
  PlatformCopy,
  GiftCopy,
  Amount,
  LeftCopy,
  MobileActionsWrapper,
  CardWrapper,
  CardCopyWrapper,
} from './giftCertificateView.styles';

export interface GiftCertificateViewProps {
  variants: Variant[];
}

export const GiftCertificateView = ({ variants }: GiftCertificateViewProps) => {
  const [theme, setTheme] = useState<Variant>();
  const cardImage = path(['value', 'image'], theme) as string;

  return (
    <Container>
      <Content>
        <CardContainer>
          <CardWrapper>
            <Card cardImage={cardImage}>
              <CardCopyWrapper>
                <CardCopy>
                  <LeftCopy>
                    <PlatformCopy>
                      <FormattedMessage id="giftCertificate.platform" defaultMessage="Platform:" />
                    </PlatformCopy>
                    <GiftCopy>
                      <FormattedMessage id="giftCertificate.giftCard" defaultMessage="Gift Card" />
                    </GiftCopy>
                  </LeftCopy>
                  <Amount>
                    <FormattedMessage id="giftCertificate.amount" defaultMessage="$100-$10000" />
                  </Amount>
                </CardCopy>
              </CardCopyWrapper>
            </Card>
          </CardWrapper>
        </CardContainer>
        <Element name={GIFT_BALANCE_LINK}>
          <GiftCertificateBalance />
        </Element>
        <Element name={GIFT_TERMS_LINK}>
          <GiftCertificateTerms />
        </Element>
        <MobileActionsWrapper>
          <GiftCertificateActions onThemeChange={setTheme} theme={theme} variants={variants} />
        </MobileActionsWrapper>
      </Content>
      <GiftCertificateSidebar onThemeChange={setTheme} theme={theme} variants={variants} />
    </Container>
  );
};
